import BaseGetters from 'baseapp/store/getters'
export default {
  ...BaseGetters,
  sellerCompanyid: function (state) {
    return state.sellerCompanyid
  },
  contractSkuCount: function (state) {
    return function (contractid, skuid, defaultValue) {
      if (contractid in state.contractSkuCounts) {
        if (skuid in state.contractSkuCounts[contractid]) {
          let skuObj = state.contractSkuCounts[contractid][skuid]
          if (typeof skuObj === 'object') {
            return skuObj.count
          }
          return skuObj
        }
      }
      return defaultValue
    }
  },
  contractSkuChecked: function (state) {
    return function (contractid, skuid, defaultValue) {
      if (contractid in state.contractSkuCounts) {
        if (skuid in state.contractSkuCounts[contractid]) {
          let skuObj = state.contractSkuCounts[contractid][skuid]
          if (typeof skuObj === 'object') {
            return skuObj.checked
          }
          return true
        }
      }
      return defaultValue
    }
  },
  hasContractSkuState: function (state) {
    return function (contractid) {
      return (contractid in state.contractSkuCounts)
    }
  },
  buyerUserid: function (state) {
    let userInfoEx = state.userInfo
    if (userInfoEx.isValid()) {
      return userInfoEx.data.userid
    }
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/apps/buyerapp/store/getters.js